module.exports = __webpack_public_path__ + "static/img/wjlogo.46f670e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wjlogo.png
// module id = wW1J
// module chunks = 19